/**
 * The one home for the serializer family's HTML-entity escape pair
 * (render-email-html.ts, template-variables.ts, utm-params.ts all import it —
 * previously three keep-in-sync copies). Server-safe, no imports.
 *
 * Ordering is the correctness rule: escape encodes `&` FIRST (so the other
 * entities' own ampersands aren't double-encoded) and decode resolves `&amp;`
 * LAST (so pre-existing entities round-trip byte-identically).
 */

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function decodeHtml(value: string): string {
  return value
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&");
}
